import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { PickingQueueItem } from '../warehouseDashboardTypes';
import styles from './PickingQueue.module.css';

interface PickingQueueProps {
  items: PickingQueueItem[];
}

const priorityColorMap: Record<string, string> = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
};

export const PickingQueue: React.FC<PickingQueueProps> = ({ items }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.card}>
      <h3 className={styles.heading}>Today's Picking Queue</h3>
      <div className={styles.list}>
        {items.map((item) => (
          <div
            key={item.id}
            className={`${styles.orderCard} ${styles[`border_${priorityColorMap[item.priority]}`]}`}
          >
            <div className={styles.orderHeader}>
              <span className={styles.orderId}>{item.orderId}</span>
              <div className={styles.badges}>
                <span className={styles.statusBadge}>{item.status}</span>
                <span className={`${styles.priorityBadge} ${styles[`priority_${priorityColorMap[item.priority]}`]}`}>
                  {item.priority}
                </span>
              </div>
            </div>
            <p className={styles.itemCount}>{item.itemCount} items</p>
            <button
              type="button"
              className={styles.pickButton}
              onClick={() => navigate(`/pick-pack?order=${encodeURIComponent(item.orderId)}`)}
            >
              Start Picking
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
